import { Subject } from 'rxjs';

const subject = new Subject();

export const messageService = {
    sendMessage: message => subject.next({ text: message }),
    getMessage: () => subject.asObservable()
};



// WEBPACK FOOTER //
// ./src/centro-atencion-gnp/centro-atencion.service.js